module.exports = __webpack_public_path__ + "static/media/ricardo-barbosa.b259a5a3.png";